import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeWizardStep, UIToggleBoolean, fetchPropertyCalcIfNeeded } from '../PropertyActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

class WizardStepNavigation extends Component {
    constructor(props) {
        super(props);
        this.previousStep = this.previousStep.bind(this);
        this.nextStep = this.nextStep.bind(this);
    }

    previousStep(event) {
        this.props.fetchPropertyCalcIfNeeded();
        var newIndex = this.props.currentWizardStepIndex - 1;
        if (newIndex >= 0) {
            this.props.changeWizardStep(newIndex);
        }
    }

    nextStep(event) {
        this.props.fetchPropertyCalcIfNeeded();
        var newIndex = this.props.currentWizardStepIndex + 1;
        if (newIndex <= this.props.numberOfSteps - 1) {
            this.props.changeWizardStep(newIndex);
        } else {
            //Do we log this event when they make a calculation and when the calcualtion is shared? For now just when it's acutally calculated
            window.dataLayer && window.dataLayer.push({'event': 'BuyToLet Calculation'})
            this.props.UIToggleBoolean("showReport");
        }
    }

    render() {
        var leftBtnText = 'Previous';
        var rightBtnText = 'Next';

        if (this.props.currentWizardStepIndex === this.props.numberOfSteps - 1) {
            rightBtnText = 'Finish';
        }

        return (
            <div className="wizard-navigation-container">
                {this.props.currentWizardStepIndex !== 0 ?
                    <a className="btn wizard-navigation-btn" onClick={this.previousStep}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                        <span>{leftBtnText}</span>
                    </a>
                    :
                    <a className="btn wizard-navigation-btn" />
                }
                <a className="btn wizard-navigation-btn" onClick={this.nextStep}>
                    <span>{rightBtnText}</span>
                    <FontAwesomeIcon icon={faChevronRight} />
                </a>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return state.property;
};

export default connect(
    mapStateToProps,
    { changeWizardStep, UIToggleBoolean, fetchPropertyCalcIfNeeded }
)(WizardStepNavigation);


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/WizardStepNavigation.jsx